import { defineStore } from 'pinia'
import type { SnackMessage } from '../core/models/snack'

export const useSnackStore = defineStore('snacks', {
  state: () => ({
    snacks: [] as SnackMessage[],
  }),

  actions: {
    show(snack: Omit<SnackMessage, 'id'>) {
      const TIMEOUT = 6 * 1000
      const id = crypto.randomUUID()
      this.snacks.unshift({
        id: id,
        text: snack.text,
        type: snack.type,
        action: snack.action,
      })
      setTimeout(() => this.dismiss(id), TIMEOUT)
    },
    showError(text: string, action?: SnackMessage['action']) {
      this.show({ text: text, type: 'error', action: action })
    },
    showInfo(text: string, action?: SnackMessage['action']) {
      this.show({ text: text, type: 'info', action: action })
    },
    dismiss(id: string) {
      this.snacks = this.snacks.filter((snack) => snack.id != id)
    },
  },
})
